import { LoadablePaint } from '@confluence/loadable';

export const ViewPageLiteLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewPageLite" */ '../src/ViewPageLite.tsx'))
			.ViewPageLite,
});
